const path = require('path')

const router = require('../../router')


module.exports = (graphql, actions, route) => {
  const { createPage } = actions
  const gameErrorContainer = path.resolve('src/containers/GameError/index.js')

  return createPage({
    path: router(route.path, {}),
    component: gameErrorContainer,
    context: {
      isVip: !!route.isVip,
    },
  })
}
